export default "__VITE_ASSET__gZiEHmtb__"